// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__tnvPa","back-btn":"ColorectalCancerScreening_back-btn__-EDRj","back-icon":"ColorectalCancerScreening_back-icon__8lrHr"};